import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useNavigatePostLogin = () => {
    const navigate = useNavigate();
    const navigatePostLogin = useCallback(() => navigate("/dashboard"), [navigate]);
    return navigatePostLogin
};
